import { getTermValue, resetTerms } from '../../../../JsonQuery';
import { TTagsManager } from '../../types/tag';
import { LAYOUT_TYPE_VALUE_TO_LABEL } from './constants';
import { ELayoutType } from '../../../../api-models/common/json_query';
import { createTagValue } from '../../utils/createTagValue';

const ID = 'layoutType' as const;

export const layoutTypeTagManager: TTagsManager = {
  id: ID,
  extractTagsFromJsonQuery: ({ jsonQuery }) => {
    const layoutType = getTermValue('room_type')(jsonQuery);

    if (layoutType === null || layoutType === ELayoutType.Any) {
      return null;
    }

    const label = `${LAYOUT_TYPE_VALUE_TO_LABEL[layoutType]} комнаты`;

    return [{ label, value: createTagValue(ID) }];
  },
  modifyJsonQueryByRemovingTag: ({ jsonQuery }) => resetTerms(['room_type'])(jsonQuery),
};
